export const dataSource_tonghao = [
  { key: '0', title: '关注' },
  { key: '1', title: '发现' },
  { key: '2', title: '笔墨点亮生活' },
  { key: '3', title: '好作业' },
  { key: '4', title: '学习感悟' },
  { key: '5', title: '回后山' },
  { key: '6', title: '小食光' },
  { key: '7', title: '暄桐雅会' },
  { key: '8', title: '桐学雅会' },
  { key: '9', title: '桐学作品' }
]

export const dataSource_tonghaoV2 = [
  { key: '0', title: '关注' },
  { key: '1', title: '发现' },
  { key: '10', title: '杭州分桐' },
  { key: '2', title: '笔墨点亮生活' },
  { key: '3', title: '好作业' },
  { key: '4', title: '学习感悟' },
  { key: '5', title: '回后山' },
  { key: '6', title: '小食光' },
  { key: '7', title: '暄桐雅会' },
  { key: '8', title: '桐学雅会' },
  { key: '9', title: '桐学作品' }
]
